var $1a04cd004166540e$exports = {};
$1a04cd004166540e$exports = {
    "colorSwatchPicker": `Kr\u{101}su paraugi`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izv\u{113}l\u{113}ties vienumu`,
    "tableResizer": `Izm\u{113}ra main\u{12B}t\u{101}js`
};


export {$1a04cd004166540e$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
